var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaxonomynavigationshortlight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 382.41 68.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #c2c4d8;\n      }\n\n      .cls-3 {\n        font-family: RobotoSlab-Regular, 'Roboto Slab';\n        font-size: 19.35px;\n      }\n\n      .cls-4 {\n        letter-spacing: 0em;\n      }\n\n      .cls-5 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-6 {\n        fill: #b4a7c5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M60.6,34.07c0-10.4,4.09-19.85,10.74-26.86H30.47C13.64,7.21,0,20.85,0,37.68H0c0,16.83,13.64,30.47,30.47,30.47h42.8c2.13,0,4.21-.22,6.22-.64-11.31-6.85-18.88-19.28-18.88-33.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.06,50.42V31.39l12.69-9.52,12.69,9.52v19.03h-9.52v-11.1h-6.34v11.1h-9.52Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 65.6,
    y: 0,
    width: 194.03,
    height: 68.14,
    rx: 34.07,
    ry: 34.07
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(86.93 40.13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 0,
    y: 0
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.7,
    y: 0
  }, "alconifor"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 94.27,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    x: 112.46,
    y: 0
  }, "es")))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 228.76,
    y: 0,
    width: 153.65,
    height: 68.14,
    rx: 34.07,
    ry: 34.07
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(247.84 40.13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 0,
    y: 0
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.7,
    y: 0
  }, "alconidae")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxonomynavigationshortlight);
export default __webpack_public_path__ + "static/media/taxonomy navigation short light.f58fb3d9a2650a43d9fe183ace3b9456.svg";
export { ForwardRef as ReactComponent };